export { GeneralContentBlockWithLiveText as GeneralContentBlockWithLiveTextReduced } from "./GeneralContentBlockWithLiveText"
